import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { base_path } from './shared/config/basePath'
import Login from './pages/shared/loginuser';
import { withMsal } from '@azure/msal-react';
import SsoAuthHandler from './components/SsoAuthHandler';
import LoginContent from './pages/shared/cognito/LoginContent';
import ProtectedRoute from './shared/core/ProtectedRoute';
import { LOGIN_REQUESTING } from './redux/constants/shared/loginUserConstants';
import { FETCH_THEME_S3_REQUEST } from './redux/constants/shared/themeConstants';
import { FETCH_FEATURE_REQUEST } from './redux/constants/shared/featureConstant';
import { INIT_DRAWER } from './redux/constants/shared/appStatesConstants';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import Error from './shared/errors/Error';
import UniversalHome from './pages';
import { con } from './shared/config/config';
import WaitingPage from './pages/shared/fileDetail/components/waitingPage/WaitingPage';

class App extends Component {
  componentDidMount() {
    const { loadtheme, loadfeature, updateDrawerMenu, callAuthCheck, msalContext } = this.props;
    this.setAppTitle();
    loadtheme();
    loadfeature();
    updateDrawerMenu('cv');
    const msalAccounts = msalContext?.instance?.getAllAccounts?.() || [];
    if (msalAccounts.length === 0) {
      callAuthCheck();
    }
  }
  
  setAppTitle() {
    if(con.PRODUCT_TITLE){
      let envTitle;
      if(con.ENVIRONMENT === 'QA' || con.ENVIRONMENT === 'QABLUE'){
        envTitle = 'QA';
      }
      if(con.ENVIRONMENT === 'DEV' || con.ENVIRONMENT === 'LOCAL'){
        envTitle = 'DEV';
      }
      document.title = (!!envTitle) ? `${con.PRODUCT_TITLE} - Vault (${envTitle})` : `${con.PRODUCT_TITLE} - Vault`;
    }
  }

  render() {
    const { themeFetching, themeError } = this.props;
    if (themeError)
      return (
        this.renderError()
      )

    return (
      themeFetching ? this.renderNothing() : this.renderContent()
    );
  }

  renderError() {
    const { themeError } = this.props;
    return (
      <Error
        error={themeError}
      />
    )
  }
  renderNothing() {
    return (
      <div></div>
    )
  }

  renderContent() {
    let thirdPartyPaths = [];
    const thirdPartyLoginLayoutFeatures = this.props.features.thirdPartyLoginLayout;
    if (thirdPartyLoginLayoutFeatures && thirdPartyLoginLayoutFeatures.length) {
      thirdPartyLoginLayoutFeatures.forEach(element => {
        const loginUrls = Object.values(element)[0]['login-urls'];
        loginUrls && thirdPartyPaths.push(...loginUrls);
      });
    }
    const themeResponse = this.props.themeResponse;
    themeResponse.palette = {
      primary: {
        main: this.props.themeResponse.gridheaderbgcolor,
      },
      secondary: {
        main: this.props.themeResponse.appbarbgcolor
      }
    }
    const theme = createMuiTheme(
      themeResponse
    )

    const { msalContext, loggedIn } = this.props;
    // Use live MSAL cache instead of stale React props — during logout the
    // cache is cleared by optionHandle BEFORE the React re-render, so checking
    // the live cache prevents the blank-page-during-logout issue.
    const msalAuthenticated = msalContext?.instance?.getAllAccounts()?.length > 0;
    const reduxAuthenticated = loggedIn?.successful === true;
    const isLoggingOut = loggedIn?.loggingOut === true;
    const isUnauthorized = loggedIn?.unauthorized === true;

    // Show a blank loading screen while SsoAuthHandler syncs MSAL → Redux
    // but NOT during logout or when the user is unauthorized — in those cases
    // we need the routes to render so /error or /login can be displayed.
    const isSyncingAuth = msalAuthenticated && !reduxAuthenticated && !isLoggingOut && !isUnauthorized;

    console.debug('App render - msalAuth:', msalAuthenticated, 'reduxAuth:', reduxAuthenticated, 'syncing:', isSyncingAuth, 'unauthorized:', isUnauthorized);

    if (isSyncingAuth) {
      return (
        <MuiThemeProvider theme={theme}>
          <SsoAuthHandler />
        </MuiThemeProvider>
      );
    }

    return (
      <MuiThemeProvider theme={theme}>
        <SsoAuthHandler />
        <Switch>
          {/* Public routes always accessible */}
          <Route exact path="/invite" component={Login} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/logout" component={Login} />
          <Route exact path="/userauth/userlogin" component={LoginContent} />
          <Route exact path="/advisor/login" render={() => <Login discriminator="advisor" />} />
          <Route exact path="/error" render={() => <Login unauthorized={true} />} />
          <Route exact path={`/waiting(/.*)?`} render={() => <WaitingPage />} />
          {thirdPartyPaths.map((thirdPartyPath) => (
            <Route key={thirdPartyPath} exact path={`${thirdPartyPath}`} render={() => <Login discriminator="thirdparty" />} />
          ))}
          {/* Authenticated routes — ProtectedRoute redirects to /login if not logged in */}
          <Route exact path="/" render={() => <Redirect to="/customer" />} />
          <ProtectedRoute path={`/customer(/.*)?`} render={() => <UniversalHome />} />
          <ProtectedRoute exact path={`${base_path}`} render={() => <UniversalHome />} />
          {/* Fallback: redirect unauthenticated users to login */}
          <Route render={() => <Redirect to="/login" />} />
        </Switch>
      </MuiThemeProvider>
    )
  }
}

App.propTypes = {
  callAuthCheck: PropTypes.func.isRequired,
  loadtheme: PropTypes.func.isRequired,
  loadfeature: PropTypes.func.isRequired,
  updateDrawerMenu: PropTypes.func.isRequired,
  msalContext: PropTypes.object,
  themeFetching: PropTypes.bool,
  themeError: PropTypes.any,
  themeResponse: PropTypes.object,
  loggedIn: PropTypes.object,
  features: PropTypes.object,
  productInfo: PropTypes.any,
  fetching: PropTypes.bool,
  error: PropTypes.any,
};

const mapStateToProps = state => {
  return {
    fetching: state.appReducer.fetching,
    error: state.appReducer.error,
    themeFetching: state.themeReducer.themeFile.fetching,
    themeResponse: state.themeReducer.themeFile.content,
    themeError: state.themeReducer.themeFile.error,
    loggedIn: state.login,
    features: state.homeReducer.features,
    productInfo: state.homeReducer.productInfo.response,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    callAuthCheck: () => dispatch({ type: LOGIN_REQUESTING }),
    loadtheme: () => dispatch({ type: FETCH_THEME_S3_REQUEST }),
    loadfeature: () => dispatch({ type: FETCH_FEATURE_REQUEST }),
    updateDrawerMenu: (product) => dispatch({ type: INIT_DRAWER, product: product })
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withMsal(App)))
